import request from '@/utils/request'

// 获取系统配置
export function getSystemConfig() {
  return request({
    url: '/magic-api/system/config',
    method: 'get'
  })
}

